import React from "react";


const DashboardStats = () => {
    return (
        <>
            {/* Quick Stats */}
            <div className="mt-8 pt-4 border-t border-border">
                <div className="px-3 mb-3">
                    <h4 className="text-xs font-semibold text-muted-foreground uppercase tracking-wider">
                        Quick Stats
                    </h4>
                </div>
                <div className="space-y-2">
                    <div className="flex items-center justify-between px-3 py-2 text-xs">
                        <span className="text-muted-foreground">Total Views</span>
                        <span className="font-semibold text-purple-600">12.5K</span>
                    </div>
                    <div className="flex items-center justify-between px-3 py-2 text-xs">
                        <span className="text-muted-foreground">This Month</span>
                        <span className="font-semibold text-green-600">+23%</span>
                    </div>
                    <div className="flex items-center justify-between px-3 py-2 text-xs">
                        <span className="text-muted-foreground">Active Users</span>
                        <span className="font-semibold text-blue-600">234</span>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DashboardStats;